<script>
  export default {
    name: 'capsim-list',
    data() {
      return {
        refreshKey: 0,
      };
    },
    props: {
      className: {
        type: String,
        default: '',
      },
      isHtml: {
        type: Boolean,
        default: false,
      },
      collection: {
        type: [Array, Object],
        default: () => [],
      },
      badges: {
        type: Array,
        default: () => [],
      },
      onClick: {
        type: Function,
        default: () => {},
      },
    },
    watch: {
      badges(newVal, oldVal) {
        if (newVal[0] !== oldVal[0]) {
          this.refreshKey += 1; // Increment refreshKey to trigger reactivity
        }
      },
    },
  };
</script>
<template>
  <ul id="capsim-list" class="list-group" :key="refreshKey">
    <template v-for="(value, key, idx) in collection">
      <li
        :class="className"
        @click="onClick(idx, key)"
        tabindex="0"
        v-on:keyup.enter="$event.target.click()"
        v-on:keyup.space="$event.target.click()"
        :key="value.id"
      >
        <template v-if="isHtml">
          <div class="row" v-html="value"></div>
        </template>
        <template v-else>
          <span>{{ value }}</span>
        </template>
        <template v-if="badges">
          <span class="badge">{{ badges[idx] }}</span>
        </template>
      </li>
    </template>
  </ul>
</template>
<style></style>
